import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
const RadioChecked = forwardRef(({ ...props }, ref) => {
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-hidden": ariaHidden, ...props, children: [_jsx("circle", { cx: 8, cy: 8, r: 8, fill: "#0090e3", className: "RadioChecked-circle" }), _jsx("circle", { cx: 8, cy: 8, r: 3, fill: "#fff" })] }));
});
RadioChecked.displayName = 'RadioChecked';
export default RadioChecked;
//# sourceMappingURL=RadioChecked.js.map